import classNames from 'classnames';
import { ICustomActions } from '../../common/data/base/custom-actions';
import useDarkMode from '../../hooks/useDarkMode';
import Button from '../bootstrap/Button';
import Dropdown, { DropdownItem, DropdownMenu, DropdownToggle } from '../bootstrap/Dropdown';

interface Props {
	id?: string;
	showEdit?: boolean;
	showInactivate?: boolean;
	showDelete?: boolean;
	onEditClick?: (id: string) => void;
	onInactivateClick?: (id: string) => void;
	onDeleteClick?: (id: string) => void;
	customActions?: ICustomActions[];
}

export const MoreActions = ({ id, showEdit, showInactivate, showDelete, onEditClick, onInactivateClick, onDeleteClick, customActions }: Props) => {
	const { darkModeStatus } = useDarkMode();

	return (
		<td className='text-end'>
			<Dropdown>
				<DropdownToggle hasIcon={false}>
					<Button icon='MoreHoriz' color='dark' isLight shadow='sm' aria-label='Mais Ações' />
				</DropdownToggle>
				<DropdownMenu isAlignmentEnd>
					{showEdit && onEditClick && id && (
						<DropdownItem>
							<Button
								isOutline={!darkModeStatus}
								color='dark'
								isLight={darkModeStatus}
								className={classNames('text-nowrap', {
									'border-light': !darkModeStatus,
								})}
								icon='Edit'
								onClick={() => onEditClick(id)}>
								Alterar
							</Button>
						</DropdownItem>
					)}

					{showInactivate && onInactivateClick && id && (
						<DropdownItem>
							<Button
								isOutline={!darkModeStatus}
								color='dark'
								isLight={darkModeStatus}
								className={classNames('text-nowrap', {
									'border-light': !darkModeStatus,
								})}
								icon='Delete'
								onClick={() => onInactivateClick(id)}>
								Inativar
							</Button>
						</DropdownItem>
					)}

					{showDelete && onDeleteClick && id && (
						<DropdownItem>
							<Button
								isOutline={!darkModeStatus}
								color='dark'
								isLight={darkModeStatus}
								className={classNames('text-nowrap', {
									'border-light': !darkModeStatus,
								})}
								icon='Delete'
								onClick={() => onDeleteClick(id)}>
								Remover
							</Button>
						</DropdownItem>
					)}

					{customActions && id && (
						customActions?.map((action, index) => (
							<DropdownItem key={index}>
								<Button
								isOutline={!darkModeStatus}
								color='dark'
								isLight={darkModeStatus}
								className={classNames('text-nowrap', {
									'border-light': !darkModeStatus,
								})}
								icon={action.icon}
								onClick={() => action.onClickAction(id)}>
								{action.label}
							</Button>
							</DropdownItem>
						))
					)}
				</DropdownMenu>
			</Dropdown>
		</td>
	);
};
